import { render, staticRenderFns } from "./TicketEvento.vue?vue&type=template&id=667c0496&"
import script from "./TicketEvento.vue?vue&type=script&lang=js&"
export * from "./TicketEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports